import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFlow,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import ActivitiesDetailsSectionInfo from '../sections/ActivitiesDetailsSectionInfo';
import ActivitiesDetailsSectionSecondaryInfo from '../sections/ActivitiesDetailsSectionSecondaryInfo';

export default function ActivitiesDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<ActivitiesDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<ActivitiesDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="acti_descriptionhtml"
							value={props.model.acti_descriptionhtml}
							isEdit={props.isEdit}
							logProps={props.logProps}
							sendChange={props.sendChange}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="activities" uid={props.model.acti_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionFlow
							module="activities"
							model={props.model}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
